module.exports = __webpack_public_path__ + "img/slider.ddb102ae.svg";